<template>
  <div class="product-row">
    <div class="product-row-header">
      <span class="product-row-label">{{ product.name }}</span>
    </div>
    <div class="product-row-body">
      <div class="upload-section">
        <div class="upload-label">主参考图</div>
        <div class="upload-area" @click="triggerMainUpload" :class="{ 'has-image': product.mainPreview }">
          <template v-if="product.mainPreview">
            <img :src="product.mainPreview" class="upload-preview" />
            <div class="upload-overlay">
              <button class="upload-overlay-btn" @click.stop="workbench.clearProductMainImage(product.id)">删除</button>
            </div>
          </template>
          <template v-else>
            <svg class="upload-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="3" width="18" height="18" rx="2"/>
              <line x1="12" y1="8" x2="12" y2="16"/>
              <line x1="8" y1="12" x2="16" y2="12"/>
            </svg>
            <span class="upload-text">上传主图</span>
          </template>
        </div>
        <input ref="mainInput" type="file" accept="image/*" class="hidden-input" @change="onMainChange" />
      </div>
      <div class="upload-section">
        <div class="upload-label">细节参考图 ({{ product.detailPreviews.length }})</div>
        <div class="detail-previews">
          <div v-for="(preview, idx) in product.detailPreviews" :key="idx" class="detail-thumb">
            <img :src="preview" />
            <button class="detail-remove" @click="workbench.removeProductDetailImage(product.id, idx)">&times;</button>
          </div>
          <div class="detail-add" @click="triggerDetailUpload">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
          </div>
        </div>
        <input ref="detailInput" type="file" accept="image/*" multiple class="hidden-input" @change="onDetailChange" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'

// eslint-disable-next-line no-undef
const props = defineProps({
  product: { type: Object, required: true }
})

const workbench = useWorkbenchStore()
const mainInput = ref(null)
const detailInput = ref(null)

const triggerMainUpload = () => { mainInput.value.value = ''; mainInput.value.click() }
const triggerDetailUpload = () => { detailInput.value.value = ''; detailInput.value.click() }

const onMainChange = (e) => {
  const file = e.target.files?.[0]
  if (file) workbench.setProductMainImage(props.product.id, file)
}

const onDetailChange = (e) => {
  const files = Array.from(e.target.files || [])
  if (files.length) workbench.addProductDetailImages(props.product.id, files)
}
</script>
